function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Logout icon");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u2693\\uFE0F-The-Shipyard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u260DQronoport-/-Foundation-/-icons-/-log-out",
  transform: "translate(-3.000000, -2.000000)",
  fill: "#06273A"
}, React.createElement("path", {
  d: "M14.7924932,9.20750677 C14.5388347,8.9538482 14.4397697,8.58413278 14.5326152,8.23762873 C14.6254607,7.89112467 14.8961111,7.6204742 15.2426152,7.52762872 C15.5891193,7.43478324 15.9588347,7.53384819 16.2124932,7.78750677 L20.2124932,11.7875068 C20.3035339,11.8826105 20.3748989,11.9947555 20.4224932,12.1175068 C20.5225113,12.3609681 20.5225113,12.6340454 20.4224932,12.8775068 C20.3748989,13.0002581 20.3035339,13.1124031 20.2124932,13.2075068 L16.2124932,17.2075068 C16.0247266,17.3968194 15.7691308,17.5033051 15.5024932,17.5033051 C15.2358557,17.5033051 14.9802598,17.3968194 14.7924932,17.2075068 C14.6031806,17.0197402 14.4966949,16.7641443 14.4966949,16.4975068 C14.4966949,16.2308692 14.6031806,15.9752734 14.7924932,15.7875068 L17.0924932,13.4975068 L9.50249324,13.4975068 C8.95020849,13.4975068 8.50249324,13.0497915 8.50249324,12.4975068 C8.50249324,11.945222 8.95020849,11.4975068 9.50249324,11.4975068 L17.0924932,11.4975068 L14.7924932,9.20750677 Z M11.5024932,21.4975068 C11.5024932,22.0497915 11.054778,22.4975068 10.5024932,22.4975068 L6.50249324,22.4975068 C4.84563898,22.4975068 3.50249324,21.154361 3.50249324,19.4975068 L3.50249324,5.49750676 C3.50249324,3.84065251 4.84563898,2.49750676 6.50249324,2.49750676 L10.5024932,2.49750676 C11.054778,2.49750676 11.5024932,2.94522201 11.5024932,3.49750676 C11.5024932,4.04979151 11.054778,4.49750676 10.5024932,4.49750676 L6.50249324,4.49750676 C5.95020848,4.49750676 5.50249324,4.94522202 5.50249324,5.49750676 L5.50249324,19.4975068 C5.50249324,20.0497915 5.95020848,20.4975068 6.50249324,20.4975068 L10.5024932,20.4975068 C11.054778,20.4975068 11.5024932,20.945222 11.5024932,21.4975068 Z",
  id: "LogoutIcon"
})));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.c3b984b4.svg";
export { ForwardRef as ReactComponent };